//*******************************************************************************//
//--------------------------------- P I E ---------------------------------------//
//*******************************************************************************//
const chartPie1 = {
  series: [44, 55, 13, 43, 22],
  options: {
    labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
    legend: {
      position: 'bottom'
    },
    chart: {
      type: 'pie',
    }
  }
}

//*******************************************************************************//
//--------------------------------- B A R ---------------------------------------//
//*******************************************************************************//
let chartBar1 = {
  series: [{
      name: 'Opérateur',
      data: [44, 55, 57, 0]
    }, {
      name: 'Maintenance',
      data: [76, 85, 101, 0]
    }, {
      name: 'Responsable',
      data: [35, 41, 36, 0]
    }, {
      name: 'Déplacement',
      data: [35, 41, 36, 0]
    }
  ],
  chartOptions: {
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
      },
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },

    xaxis: {
      categories: ['Feb', 'Mar', 'Apr', 'May'],
    },
    yaxis: {
      title: {
        text: 'TEMPS'
      }
    },
    fill: {
      opacity: 1

    },
    tooltip: {
      y: {
        formatter: function (val) {
          return `${new Date(val).getHours()}H${new Date(val).getMinutes()}`;
        }
      }
    }
  }
}

export { chartPie1, chartBar1 }